import { IAppState } from '../../../AppModulesWrapper';

export const selectCanPayByCard = (state: IAppState): boolean => {
  return !!state.servicePickerWidget.user.canPayByCard;
};
